import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  Switch,
} from "@/components/ui";
import { useFormContext, type UseFormRegisterReturn } from "react-hook-form";

interface SwitchFormFieldProps {
  register: UseFormRegisterReturn;
  label?: React.ReactNode;
  disabled?: boolean;
  disabledTooltip?: string;
  onChange?: (checked: boolean) => void;
  "data-testid"?: string;
}

export const SwitchFormField = ({
  register,
  label,
  disabled,
  onChange,
  "data-testid": dataTestId,
}: SwitchFormFieldProps) => {
  const form = useFormContext();
  return (
    <FormField
      control={form.control}
      {...register}
      //@ts-expect-error This line is to remove a console error
      ref={null}
      render={({ field }) => (
        <FormItem className="flex flex-row items-center gap-3 space-y-0">
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                onChange?.(checked);
              }}
              disabled={disabled}
              data-testid={dataTestId}
            />
          </FormControl>
          {label ? (
            typeof label === "string" ? (
              <FormLabel>{label}</FormLabel>
            ) : (
              <FormLabel asChild>{label}</FormLabel>
            )
          ) : null}
        </FormItem>
      )}
    />
  );
};
